var map = {
	"./feature_buy_en.png": "1787",
	"./feature_buy_id.png": "cd2b",
	"./feature_buy_ko.png": "3291",
	"./feature_buy_ph.png": "7844",
	"./feature_buy_th.png": "5284",
	"./feature_buy_zh.png": "5486"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ca715";